import { useMemo } from "react";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { getGroupHeight } from "../utils/get-group-height.ts";

export function useGroupHeight(): number {
  const size = useGenomeViewerStore(
    (state) => [...state.trackGroups.values()].filter((group) => group.graphics.isVisible).length,
  );

  const groupHeight = useMemo(() => getGroupHeight(size), [size]);

  return groupHeight;
}
